import './about.css'
import Resume from '../../assets/Thomas_Frerichs_Resume.pdf'
import ResumeImage from '../../assets/resume.jpg'
import AboutImage from '../../assets/young_me2-bw.jpg'
import { IoMdOpen } from "react-icons/io"
import { LuDownload } from "react-icons/lu"
import Card from '../../components/Card'
import data from './data'

const About = () => {
  return (
    <section id="about">
      <div className="container about__container" data-aos="fade-in">
        <div className="about__left">
          <div className="about__portrait">
            <img src={AboutImage} alt="Portrait of Thomas Frerichs" />
          </div>
        </div>
        <div className="about__right">
          <h2>About Me</h2>
          <div className="about__cards">
            {
              data.map(item => (
                <Card key={item.id} className='about__card'>
                  <span className='about__card-icon'>{item.icon}</span>
                  <h5>{item.title}</h5>
                  <small>{item.desc}</small>
                </Card>
              ))
            }
          </div>
          <p>
            I grew up in the small town of Little Falls, Minneosta. I've always been passionate about technology and how it can be used to solve 
            problems, or create something entirely from scratch. Around the age of 5, I started to develop an interest in video games; from there, 
            I began to question how the games worked behind the scenes. What peaked my interest was how a Ninetendo 2DS cartridge, that was so 
            small, could produce such a vast--immersive world so quickly. This curiosity led me to start learning how to code. During high school, 
            I took to modding video games and implementing new features or changing graphics; these mods have since been uploaded to Nexusmods.
            </p> 
            <p>
            I am currently a Junior at Saint Cloud State University pursuing a Bachelor of Science in Engineering degree in 
            Software Engineering. I'm also a member of the Computer Science club and the Student Organization for Software Engineers, where
            we collaborate on projects, listen to speakers in the industry, and gain insight on real-world experience. I am working at Blattner HQ in Avon, Minnesota as an IT Intern, where I am one of the primary IT contact for helpdesk support calls across the entire end-user environment for Blattner employees. I create and manage tickets in ServiceNow to minimize downtime; diagnose and troubleshoot software and network problems; set up new hardware; and manage licenses, emails, and admin accounts. Additionally, I've been utilizing new AI tools to maximize my workflow and efficiency for the company.
            </p>
            <p>
            I've been coding and modding games for a little over 5 years now, and have experience in a variety of languages such as C++, Python, JavaScript, and
            HTML/CSS. I've also worked with a variety of frameworks and libraries such as React and Node.js. I'm always pushing myself to learn
            new things and expand my knowledge by working on difficult projects, modding video games, or focusing on my education. 
            </p>
            <p>
              As of January 9th, 2026, Nexusmods has recognized me as an official Mod Author!
            </p>
            <div className="btn-group"> 
          <a href={Resume} download className='btn primary'>Download Resume<LuDownload /></a>
          <a href={ResumeImage} target="_blank" rel="noopener noreferrer" className='btn primary btn-view'><IoMdOpen /></a>
          </div> 
        </div>
      </div>
    </section>
  )
}

export default About